<template>
    <div class="store-page page safe-page pt-0px">
        <!-- tab头部 -->
        <div class="px-20px" ref="headerRef">
            <div class="sticky top-0px z-100 bg-#01031B pt-20px">
                <FixedHeader />
                <!-- <div class="sticky top-20px"> -->
                <!-- <AppHeader /> -->
                <div class="store-tab color-#fff flex">
                    <div class="store-tab-item" @click="handleTabClick(0)" :class="{ 'active': activeTab === 0 }">
                        Store
                    </div>
                    <div class="store-tab-item" @click="handleTabClick(1)" :class="{ 'active': activeTab === 1 }">
                        Record
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
        <!-- 🚀 轮播Tab内容区域 -->
        <div class="swipe-wrapper">
            <van-swipe ref="swipeRef" :loop="false" :show-indicators="false" :touchable="true"
                @change="handleSwipeChange" class="store-swipe">
                <!-- Tab 0: Store -->
                <van-swipe-item class="swipe-item-full">
                    <!-- 骨架屏 (仅在没有数据时显示) -->
                    <SkeletonStore v-if="loading && gemItems.length === 0" />

                    <!-- 错误状态 -->
                    <div v-else-if="storePageStore.error && gemItems.length === 0" class="error-state px-20px">
                        <div class="error-content">
                            <div class="color-#fff text-12px">{{ t('store.noNetwork') }}</div>
                            <div class="retry-button" @click="handleRetry">

                                <div>{{ t('errors.retry') }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- 正常内容 -->

                    <div v-else class="px-20px">

                        <!-- <div class="flex justify-between items-center">
                            <div class="vip-text" v-if="![3, 4].includes(userInfo?.role)">
                                Become a VIP with any Purchase
                            </div>
                            <div class="vip-text" v-else>
                                You are already a VIP member!
                            </div>
                            <div class="w-32px flex items-center justify-center">
                                <img src="@/assets/images/store/vip.webp" alt="" class="w-100% h-100%">
                            </div>
                        </div> -->
                        <div class="store-title">
                            *{{ t('store.rechargeFailTipStatic') }}
                            <span @click="handleContactUs">{{ t('store.contactUsLink') }} ></span>
                        </div>
                        <!-- 支付渠道切换 -->
                        <!-- <div class="flex items-center gap-12px mb-10px overflow-x-auto whitespace-nowrap"
                            v-if="gemItems.length">
                            <div class="w-69px h-32px flex items-center justify-center rounded-10px bg-#13162B flex-shrink-0"
                                v-for="(channel, cIdx) in gemItems" :key="channel.channel || cIdx"
                                @click="tabChannelClick(cIdx)">
                                <img :src="cIdx === selectedChannelIndex ? channel.icon?.selected : channel.icon?.unSelected"
                                    class="w-full h-full" />
                            </div>
                        </div> -->
                    </div>
                    <div class="w-100% h-86px mb-20px" @click="gotoVipPage">
                            <img src="@/assets/images/store/banner@2x.webp" alt="" class="w-100% h-100%">
                        </div>
                    <div class="store-content-box">
                        <div class="store-content">
                            <div class="store-item relative flip-item" :class="item.limitBuy === 1 ? 'active-item' : ''"
                                :style="{ animationDelay: `${index * 0.1}s` }"
                                v-for="(item, index) in gemItems[0]?.list" :key="item.id || index"
                                @click="handleItemClick(gemItems[0], index)">
                                <!-- 折扣率 -->
                                <div v-if="calculateDiscountRate(item.price, item.originalPrice || 0)">
                                    <div class="item-off w-66px absolute top-0px left--8px">
                                        <img src="@/assets/images/store/off.webp" alt=""
                                            class="w-66px absolute top-0 left-0"></img>
                                        <div class="text-10px font-500 color-#fff font-600 absolute top-7px left-10px">
                                            {{ t('store.popular') }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.giftAmount"
                                    class="item-dwon gift-bg w-48px h-48px absolute top--5px right--5px flex-col items-center justify-center transform rotate-20deg">
                                    <div class="gift-text w-48px  font-500 color-#fff  flex flex-col items-center">
                                        <div class="text-10px color-#CF00FF font-600 gigt">{{ t('store.gift') }}</div>
                                        <div class="text-10px color-#CF00FF ">
                                            {{ item.giftAmount }}
                                        </div>
                                    </div>
                                </div>
                                <div class="item-img ">
                                    <img :src="item.image" alt="" class="w-100% h-100%">
                                </div>
                                <div class="item-info-box">
                                    <div class="item-info flex items-center justify-center">
                                        <div class="w-13px mb-2px">
                                            <img src="@/assets/images/home/crystal.webp" alt="" class="w-100% h-100%">
                                        </div>
                                        <div class="item-info-price color-#fff text-14px font-900">
                                            {{ item.amount }}
                                        </div>
                                    </div>
                                    <div class="text-10px color-#fff font-500 text-center active-item-text"
                                        v-if="item.limitBuy === 1">One
                                        time only</div>

                                    <div class="item-btn flex items-center justify-center"
                                        :class="item.limitBuy === 1 ? 'active-item-btn' : ''">
                                        <div class="gem-price-original text-10px line-through"
                                            v-if="item.originalPrice !== item.price && item.originalPrice !== 0">
                                            ${{ Number(item.originalPrice) / 100 }}
                                        </div>
                                        <div class="gem-price ml-3px mt-2px">${{ Number(item.price) / 100 }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>

                <!-- Tab 1: Record -->
                <van-swipe-item class="swipe-item-full" @scroll="handleScroll">
                    <div class="px-20px">
                        <!-- 骨架屏 (仅在没有数据时显示) -->
                        <SkeletonRecord v-if="loading && consumptionRecords.length === 0" />

                        <!-- 错误状态 -->
                        <div v-else-if="storePageStore.error && consumptionRecords.length === 0" class="error-state">
                            <div class="error-content">
                                <div class="color-#fff text-12px">{{ t('store.noNetwork') }}</div>
                                <div class="retry-button" @click="handleRetryRecord">
                                    
                                    <div>{{ t('errors.retry') }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="store-consumption-box" ref="recordsContainerRef">
                            <!-- 🔧 虚拟列表：优化大量数据渲染 -->
                            <AppVirtualList
                                v-if="consumptionRecords.length > 0"
                                :items="consumptionRecords"
                                :item-height="80"
                                :buffer="3"
                                key-field="id"
                                :style="{ height: virtualListHeight }"
                                class="virtual-list-wrapper"
                                @reach-bottom="handleReachBottom"
                            >
                                <template #item="{ item: record }">
                                    <div class="store-consumption-item p-10px flex items-center justify-between">
                                        <div class="flex items-center">
                                            <div class="w-24px h-24px mr-10px" v-if="TypeMapImg[record.type]">
                                                <img :src="TypeMapImg[record.type]" alt="" class="w-100% h-100%">
                                            </div>
                                            <div>
                                                <div class="flex items-center">
                                                    <div class="text-14px color-#fff font-800">
                                                        {{ TypeMap[record.type] }}
                                                    </div>
                                                    <div class="color-#E74EB8 text-12px mt-3px ml-5px" v-if="record.price">
                                                        -${{ ((record.price || 0) / 100).toFixed(2) }}
                                                    </div>
                                                </div>
                                                <div class="store-consumption-item-time">
                                                    {{ formatTime(record.createdAt) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <div class="flex items-center">
                                                <div class="text-14px color-#fff font-800"
                                                    :style="{ color: TypeMapColor[record.type] }">
                                                    {{ [1, 8, 5, 6, 7, 10].includes(record.type) ? '+' : '' }}
                                                    <span>{{ record.amount }}</span>
                                                </div>
                                                <div class="w-14px ml-5px flex">
                                                    <img src="@/assets/images/home/crystal.webp" alt="" class="w-100% h-100%">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                
                                <!-- 🔧 加载状态移到虚拟列表内部最后 -->
                                <template #footer>
                                    <div class="load-more-section p-20px text-center">
                                        <div v-if="loading" class="loading-text flex items-center justify-center">
                                            <div class="loading-spinner mr-8px"></div>
                                            <span>{{ t('store.loading') }}</span>
                                        </div>
                                        <div v-else-if="!hasMoreConsumption" class="no-more-text">
                                            {{ t('store.noMoreRecords') }}
                                        </div>
                                    </div>
                                </template>
                            </AppVirtualList>

                            <!-- 空状态 -->
                            <div v-if="consumptionRecords.length === 0 && !loading"
                                class="empty-state p-40px text-center">
                                <div class="text-16px color-#666 mb-10px">{{ t('store.noConsumptionRecords') }}</div>
                                <div class="text-12px color-#999">{{ t('store.transactionHistoryAppear') }}</div>
                            </div>
                        </div>

                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- <AppOccupySpace height="100px"></AppOccupySpace> -->
        <popupSlide v-model:showPopup="showPopup" />

    </div>
</template>

<script setup lang="ts" name="storePage">
import { useUserStore } from '@/stores/user'
import { FixedHeader } from '@/components/layout'
import { onMounted, onUnmounted, computed, ref, nextTick, watch } from 'vue'
import { useStorePageStore } from '@/stores/store'
import theme, { type ThemeColors } from '@/styles/theme'
import bridge from '@/utils/bridge'
import { deviceStorage } from '@/utils/storage';
import popupSlide from '../home/com/FirstChargePopUp.vue'
import { getCheckOrderStatus, getH5Payment } from './index'
import { TypeMap, TypeMapColor, TypeMapImg } from './index'
import { showLoadingToast, closeToast } from '@/utils/toast'
import { logEventSafe } from "@/plugins/firebase"
import { SkeletonStore, SkeletonRecord } from '@/components/display/Skeleton'
import AppVirtualList from '@/components/display/AppVirtualList.vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const userInfo = computed(() => userStore.getTouristInfo())
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))

// 主题颜色（用于 v-bind）
const themeColors: ThemeColors = theme.colors

const router = useRouter()
const storePageStore = useStorePageStore()
const userStore = useUserStore()
const { t } = useI18n()
const showPopup = ref(false)
const selectedChannelIndex = ref(0)
// 🚀 轮播组件引用
const swipeRef = ref()
// 🔧 消费记录容器引用
const recordsContainerRef = ref<HTMLElement>()
// 🔧 虚拟列表动态高度
const virtualListHeight = ref('600px')
const headerRef = ref<HTMLElement>()
// 使用store的状态和方法
const activeTab = computed({
    get: () => storePageStore.activeTab,
    set: (value: number) => storePageStore.switchTab(value)
})

const gemItems = computed(() => storePageStore.rechargeItems)
const consumptionRecords = computed(() => storePageStore.consumptionRecords)
const loading = computed(() => storePageStore.loading)
const hasMoreConsumption = computed(() => storePageStore.hasMoreConsumption)

/**
 * 计算折扣率
 */
const calculateDiscountRate = (price: number, originalPrice: number): number => {
    return storePageStore.calculateDiscountRate(price, originalPrice)
}

/**
 * 处理充值商品点击
 */
const handleItemClick = async (item: any, index: number) => {

    logEventSafe('store_pricebutton_click');

    localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    if (item.name === 'Apple') {
        bridge.callApp('inAppPayLoad', {
            item: item.list[index],
            url: '/applePurchase'
        })
    } else {
        // H5 支付
        await getH5Payment(item, index, userInfo.value, deviceStorage)
    }
    // if (localStorage.getItem('first_pay_success_to_vippage') !== '1') {
    //     // logEventSafe('first_pay_success_to_tabstore');
    // }
}

const tabChannelClick = (index: number) => {
    selectedChannelIndex.value = index
    localStorage.setItem('selectedChannelIndex', String(index))
}

/**
 * 处理tab切换
 */
const handleTabClick = async (tabIndex: number) => {
    // 🚀 同步轮播位置
    if (swipeRef.value && activeTab.value !== tabIndex) {
        swipeRef.value.swipeTo(tabIndex, { immediate: false })
    }
    await storePageStore.switchTab(tabIndex)
}

// 🚀 轮播切换事件（滑动触发）
const handleSwipeChange = async (index: number) => {
    await storePageStore.switchTab(index)
}


/**
 * 加载更多消费记录
 */
const loadMoreConsumption = async () => {
    await storePageStore.loadMoreConsumption()
}

/**
 * 格式化时间显示
 */
const formatTime = (timestamp: number): string => {
    // const date = new Date(timestamp)
    return new Date(timestamp * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })
}

/**
 * 🔧 虚拟列表：处理到达底部事件
 */
const handleReachBottom = async () => {
    if (hasMoreConsumption.value && !loading.value) {
        await loadMoreConsumption()
    }
}

/**
 * 处理滚动事件 - 实现滚动加载更多（保留用于其他场景）
 */
const handleScroll = async (event: Event) => {
    const target = event.target as HTMLElement
    if (!target) return

    const scrollTop = target.scrollTop
    const scrollHeight = target.scrollHeight
    const clientHeight = target.clientHeight

    // 当滚动到距离底部 100px 以内时触发加载
    const distanceToBottom = scrollHeight - scrollTop - clientHeight

    if (distanceToBottom < 100 && hasMoreConsumption.value && !loading.value) {
        await loadMoreConsumption()
    }
}

/**
 * 处理联系我们
*/
const handleContactUs = () => {
    showLoadingToast(t('dialog.processing'),{duration: 2000})
    window.location.href = userData.value.reportLost|| 'https://forms.gle/6c5dh2JpfbEcZfST8'
    setTimeout(() => {
        closeToast()
    }, 2000)
}

/**
 * 🔧 重试加载 Store tab
 */
const handleRetry = async () => {
    console.log('🔄 Retrying to load store data...')
    // 清除错误状态和数据，让骨架屏显示
    storePageStore.error = null
    storePageStore.rechargeItems = []
    await storePageStore.fetchRechargeItems(true)
}

/**
 * 🔧 重试加载 Record tab
 */
const handleRetryRecord = async () => {
    console.log('🔄 Retrying to load record data...')
    // 清除错误状态和数据，让骨架屏显示
    storePageStore.error = null
    storePageStore.consumptionRecords = []
    await storePageStore.fetchConsumptionRecords(1, true)
}




/**
 * 🔧 动态计算虚拟列表高度
 */
const updateVirtualListHeight = () => {
    if (!recordsContainerRef.value) {
        // 如果容器还没渲染，使用默认值
        const windowHeight = window.innerHeight
        const headerHeight = headerRef.value?.getBoundingClientRect().height || 0 // 顶部 tab 和标题的大致高度
        const bottomPadding = 60 // 底部安全区域
        virtualListHeight.value = `${windowHeight - headerHeight - bottomPadding}px`
        return
    }
    
    // 获取容器的位置信息
    const rect = recordsContainerRef.value.getBoundingClientRect()
    const windowHeight = window.innerHeight
    
    // 计算可用高度：窗口高度 - 容器顶部位置 - 底部安全区域
    const availableHeight = windowHeight - rect.top - 60
    
    // 设置最小高度 400px，最大使用可用高度
    const finalHeight = Math.max(400, Math.min(availableHeight, windowHeight - 200))
    
    virtualListHeight.value = `${finalHeight}px`
    
    console.log('📏 虚拟列表高度更新:', virtualListHeight.value)
}

// 🔧 监听窗口大小变化
let resizeTimer: NodeJS.Timeout | null = null
const handleWindowResize = () => {
    if (resizeTimer) clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
        updateVirtualListHeight()
    }, 200)
}

const gotoVipPage = () => {
   router.push({
    path: '/vip',
    query: {
        type: 'u'
    }
   })
}

onMounted(async () => {
    selectedChannelIndex.value = Number(localStorage.getItem('selectedChannelIndex') || 0)
    await getCheckOrderStatus()
    await storePageStore.initialize()
    logEventSafe('tab_store_view');
    closeToast()
    
    // 🚀 初始化轮播位置
    nextTick(() => {
        if (swipeRef.value) {
            swipeRef.value.swipeTo(activeTab.value, { immediate: true })
        }
        
        // 🔧 初始化虚拟列表高度
        setTimeout(() => {
            updateVirtualListHeight()
        }, 300)
    })
    
    // 🔧 监听窗口大小变化
    window.addEventListener('resize', handleWindowResize)
})

// 🔧 监听 tab 切换，重新计算高度
watch(activeTab, (newTab) => {
    if (newTab === 1) {
        nextTick(() => {
            setTimeout(() => {
                updateVirtualListHeight()
            }, 100)
        })
    }
})

// 🔧 清理事件监听
onUnmounted(() => {
    window.removeEventListener('resize', handleWindowResize)
    if (resizeTimer) clearTimeout(resizeTimer)
})
</script>

<style lang="scss" scoped>
.store-page {
    background-color: v-bind('themeColors.background');
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .store-tab {
        margin-bottom: 10px;
        gap: 30px;

        .store-tab-item {
            font-weight: 900;
            font-size: 16px;
            color: v-bind('themeColors.textPrimary');

            &.active {
                color: #FFFFFF;
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    background: #FFFFFF;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 10px;
                    height: 2px;
                    background: linear-gradient(270deg, #C489FF 0%, #6868FF 100%);
                    border-radius: 2px;
                }
            }
        }
    }
}

// 🚀 轮播tab样式优化
.swipe-wrapper {
    flex: 1;
    overflow: hidden;
    position: relative;
}

.store-swipe {
    height: 100%;

    :deep(.van-swipe-track) {
        height: 100%;
        transform: translateZ(0);
        will-change: transform;
        backface-visibility: hidden;
    }
}

.swipe-item-full {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.store-title {
    font-size: 14px;
    color: v-bind('themeColors.textSecondary');
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 10px;

    span {
        color: #fff;
        font-weight: 700;
    }
}

.store-content-box {
    height: 100%;
    overflow-y: auto;
    padding: 0 20px;
    -webkit-overflow-scrolling: touch;
}

.store-content {
    // overflow: hidden;
    // padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;


    .store-item {
        width: calc(33.333% - 4px);
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
        background: RGBA(255, 255, 255, 0.1);
        // padding: 0 px;

        .item-info-box {
            //background-color: RGBA(34, 36, 56, 1);
            width: 100%;
            padding: 0 8px;
            padding-bottom: 10px;
            border-radius: 0 0 10px 10px;
        }

        .item-img {
            width: 64px;
            object-fit: cover;
            // filter: drop-shadow(0 4px 8px rgba(99, 102, 241, 0.3));
            display: flex;
            padding-top: 20px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 8px;
            }
        }

        .item-btn {
            margin-top: 8px;
            width: 100%;
            height: 25px;
            background-color: v-bind('themeColors.backgroundSecondary');
            border-radius: 10px;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
            border-radius: 18px;

            .gem-price-original {
                color: v-bind('themeColors.textPrimary');
            }
        }

        .gift-text {
            line-height: 10px;
            gap: 0;
        }

    }

}

.store-secure {
    font-weight: 500;
    font-size: 12px;
    color: v-bind('themeColors.textPrimary');
}

.store-consumption-box {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    // 自定义滚动条
    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2px;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    .store-consumption-item {
        margin-bottom: 10px;
        border-radius: 10px;
        background-color: v-bind('themeColors.backgroundSecondary');

        .store-consumption-item-time {
            font-weight: 500;
            font-size: 12px;
            color: v-bind('themeColors.textPrimary');
            margin-top: 4px;
        }
    }

    .load-more-section {
        .load-more-btn {
            background: linear-gradient(180deg, #9b75f3 0%, #6026cf 100%);
            color: white;
            border: none;
            border-radius: 20px;
            padding: 10px 30px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: opacity 0.3s ease;

            &:hover {
                opacity: 0.8;
            }

            &:active {
                opacity: 0.6;
            }
        }

        .loading-text {
            color: v-bind('themeColors.textSecondary');
            font-size: 14px;
            font-weight: 500;
        }

        .loading-spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.2);
            border-top: 2px solid v-bind('themeColors.textSecondary');
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        .no-more-text {
            color: v-bind('themeColors.textSecondary');
            font-size: 12px;
            font-weight: 400;
        }
    }

    .empty-state {
        .text-16px {
            font-size: 16px;
            margin-bottom: 10px;
        }

        .text-12px {
            font-size: 12px;
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

// 🔧 错误状态样式
.error-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 40px 20px;

    .error-content {
        text-align: center;
        max-width: 300px;

        .error-icon {
            font-size: 48px;
            margin-bottom: 16px;
            animation: shake 0.5s ease-in-out;
        }

        .error-title {
            font-size: 18px;
            font-weight: 600;
            color: v-bind('themeColors.textPrimary');
            margin-bottom: 8px;
        }

        .error-message {
            font-size: 14px;
            color: v-bind('themeColors.textSecondary');
            margin-bottom: 24px;
            line-height: 1.5;
        }

        .retry-button {
            font-family: Avenir, Avenir;
            font-weight: 500;
            font-size: 14px;
            color: #7284F7;
            cursor: pointer;
            text-align: center;
            margin-top: 10px;
            border-radius: 20px;
            border: 1px solid #7284F7;
            width: 100px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
        transform: translateX(-5px);
    }

    20%,
    40%,
    60%,
    80% {
        transform: translateX(5px);
    }
}

.gift-bg {
    background-image: url('@/assets/images/store/gift.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}

// 🔧 虚拟列表样式（动态高度通过 style 绑定）
.virtual-list-wrapper {
    width: 100%;
    // height 通过 :style 动态设置，不再写死
}

.active-item {
    border: 1px solid #7546C4 !important;
    // background-color: #1A1C2E;
    background: linear-gradient(180deg, #7546C4 0%, #25093E 100%) !important;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.26), rgba(255, 255, 255, 0.37)) 1 1;
    border: 1px solid;
}

.active-item-btn {
    background: linear-gradient(180deg, #A06EFA 0%, #FA6CCE 100%) !important;
}

.active-item-text {
    position: absolute;
    top: 103px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background: linear-gradient(0deg, #A06EFA 0%, #FA6CCE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.vip-text {
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    background: linear-gradient(45.00000000000003deg, #F3A14F 0%, #FFEE8D 100%);
    font-style: italic;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

// 翻转动画
.flip-item {
    animation: flipInUp 0.6s ease-out forwards;
    opacity: 0;
    transform-style: preserve-3d;
    perspective: 1000px;
}

@keyframes flipInUp {
    0% {
        opacity: 0;
        transform: perspective(1000px) rotateX(90deg) translateY(30px);
    }

    100% {
        opacity: 1;
        transform: perspective(1000px) rotateX(0deg) translateY(0);
    }
}
</style>